import angular from 'angular';
import WorkCalendar from 'common/models/work-calendar';

module.exports = angular.module('common.services.work-calendar', [])
.factory('defaultWorkCalendar', function() {
  var opts = {
    workdays: 'sun..sat',
    holidays: [
      '1/1',
      '7/4',
      '12/25'
    ]
  };
  return new WorkCalendar(opts);
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/work-calendar.js
 **/